import proptypes from 'prop-types';
import requiredIf from 'react-required-if';

const {
  bool, number, oneOf, shape, string
} = proptypes;

const BaseImageShape = {
  alt: string,
  src: string.isRequired,
  srcSet: string,
  sizes: string
};

export const LargeImageShape = shape(
  {
    ...BaseImageShape,
    width: number.isRequired,
    height: number.isRequired
  }
);

export const SmallImageShape = shape(
  {
    ...BaseImageShape,
    isFluidWidth: bool,
    /** Rendered size. Under `isFluidWidth` these are measured, not authored. */
    width: requiredIf(number, (props) => !props.isFluidWidth),
    height: requiredIf(number, (props) => !props.isFluidWidth),
    className: string,
    /** Intrinsic dimensions for the width/height attributes that reserve space (CLS). */
    intrinsicWidth: number,
    intrinsicHeight: number,
    loading: oneOf(['lazy', 'eager']),
    decoding: oneOf(['async', 'sync', 'auto']),
    /** Merged over the computed image style, for callers that must resize the image. */
    style: shape({})
  }
);